import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';
import Utils2D from 'shared/libraries/mwc/utils/utils2D.js';

export default class NodeTransformUVs extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addInput(PARAM_TYPE.FLOAT, 'u_offset', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'v_offset', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });

		this.addInput(PARAM_TYPE.FLOAT, 'uv_rotation', 0.0, { minValue: -180, maxValue: 180, units: PARAM_UNITS.DEGREES });

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'transformUVs';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		const pMeshes = Utils3D.getMeshesChildren(pGeoList);
		for(const pMesh of pMeshes)
		{
			const uvs = pMesh.getVerticesData(BABYLON.VertexBuffer.UVKind);
			if(!uvs)
				continue;
			const indices = pMesh.getIndices();

			const processedUVs = new Set();
			for (let i = 0; i < indices.length; i += 3)
			{
				for (let j = 0; j < 3; j++)
				{
					const index = indices[i + j];
					if (processedUVs.has(index))
						continue;

					processedUVs.add(index);
					const uv = new BABYLON.Vector2(uvs[index * 2], uvs[index * 2 + 1]);
					uv.x += inputValues['u_offset'];
					uv.y += inputValues['v_offset'];
					Utils2D.rotatePointToRef(uv.clone(), inputValues['uv_rotation'], uv);
					uvs[index * 2] = uv.x;
					uvs[index * 2 + 1] = uv.y;
				}
			}

			pMesh.setVerticesData(BABYLON.VertexBuffer.UVKind, uvs, false, false);
		}

		return pGeoList;
	}
}